// OneDrive:IgnoreCodeCoverage
export const enum SharingRole {
    Owner = 0,
    View = 1,
    Edit = 2,
    Submitter = 3,
    CoOwner = 4,
    None = 5,
    Review = 6,
    Custom = 7
}